<template>
  <div>
    <div>
      <b-card>
        <layout-loading v-if="itemLoading" />
        <div class="media-counseling">
          <button @click="showMedia">
            {{ $t('general.images') }}
            <feather-icon
              icon="ChevronDownIcon"
              size="18"
              opacity="1"
            />
          </button>
        </div>
        <b-form
          v-if="render"
          class="p-4 box-messages"
        >
          <b-row
            v-for="(message,index) in messages"
            :key="index"
            :class="{ 'flex-md-row-reverse' : message.status==='askedByUser' }"
          >
            <div class="d-flex flex-md-column chat-info mx-1">
              <span class="avatar">
                <feather-icon
                  icon="UserIcon"
                  size="18"
                  opacity=".6"
                  hover-opacity=".9"
                  class="margin-auto hover-scale-up"
                />
              </span>
              <span class="text-center user-name">{{ message.userId ? message.userId.fullName : '' }}</span>
            </div>
            <div
              class="bg-light bg-response p-1 mb-1 w-75 message"
              @click="reply(message , index)"
            >
              <div
                v-if="message.parentMessageId"
                class="rep-message"
              >
                <p>{{ message.parentMessageId.text }}</p>
              </div>
              <image-cell
                v-if="message.parentMessageId && message.parentMessageId.messageFileId"
                class="imageMessage rep-message"
                :src="message.parentMessageId.messageFileId"
                :value="message.parentMessageId.messageFileId"
              >
                <p>{{ message.parentMessageId.text }}</p>
              </image-cell>
              <image-cell
                v-if="message.messageFileId"
                class="imageMessage"
                :src="message.messageFileId"
                :value="message.messageFileId"
              />
              <div>
                <div v-html="replaceURLs(message.text)" />
              </div>
              <div class="chat-info">
                {{ message.createdAt | moment("jYYYY/jMM/jD HH:mm") }}
              </div>
            </div>
            <!-- edit -->
            <feather-icon
              v-if="message.seenMessageUserId.length == 0 && message.status==='repliedByAdmin'"
              icon="Edit2Icon"
              size="18"
              opacity=".6"
              hover-opacity=".9"
              class="iconEdit"
              @click="editMsg(message, index)"
            />
          </b-row>
          <div
            v-if="replyMsg"
            class="replyMsg"
          >
            <span class="sender">{{ sender }} : </span>
            <span
              v-if="!imageMsg"
              class="newMessage"
            >
              {{ newMessage }}
            </span>
            <span
              v-else
              class="newMessage"
            >
              <feather-icon
                icon="ImageIcon"
                size="18"
                opacity="1"
                class="iconImg"
              />
              {{ newMessage }}
            </span>
            <button @click="cancleRep">
              <feather-icon
                icon="XIcon"
                size="18"
                opacity="1"
                class="btn-close hover-scale-up"
                @click="closeMedia"
              />
            </button>
          </div>
          <b-modal
            v-model="editModal"
            size="lg"
            hide-footer
            hide-header
          >
            <div class="modal-dialog modal-lg modal-analayzer">
              <div class="modal-content">
                <div class="modal-header counseling">
                  <feather-icon
                    icon="XIcon"
                    size="18"
                    opacity="1"
                    class="btn-close hover-scale-up"
                    @click="closeEdit"
                  />
                </div>
                <div class="modal-body">
                  <div class="container">
                    <b-row class="mt-3 messageBox edit">
                      <b-col cols="7">
                        <b-form-group
                          :label="$t('general.message')"
                          label-for="counseling-messageEdit"
                        >
                          <b-form-textarea
                            id="counseling-messageEdit"
                            v-model="textEdit"
                            rows="6"
                            class="messageBox-text"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="5"
                        class="mb-2 boxFile"
                      >
                        <b-file-attach-input
                          id="messageAttach1"
                          v-model="form.messageFileId"
                          :label="$t('general.attach') + ' ' + $t('general.acceptAttachFile')"
                          :placeholder="$t('general.select')"
                        />
                      </b-col>
                      <b-col
                        cols="12"
                        class="mt-50"
                      >
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="primary"
                          class="mr-1"
                          :disabled="isSubmit"
                          @click="formSumbit(messages)"
                        >
                          {{ isSubmit ? $t("general.isSubmit") : $t("general.submit") }}
                        </b-button>
                        <b-button
                          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                          variant="outline-secondary"
                          @click="closeEdit"
                        >
                          {{ $t("general.back") }}
                        </b-button>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </div>
            </div>
          </b-modal>

          <b-row
            v-if="!counseling.consultantId"
            class="mt-4 justify-content-center"
          >
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-1"
              :disabled="isSubmit"
              @click="assignMe"
            >
              {{ isSubmit ? $t("general.isAssign") : $t("general.assign") }}
            </b-button>
          </b-row>
          <b-row
            v-else
            class="mt-3 messageBox"
          >
            <b-col cols="7">
              <b-form-group
                :label="$t('general.message')"
                label-for="counseling-message"
              >
                <b-form-textarea
                  id="counseling-message"
                  v-model="form.message"
                  rows="6"
                  class="messageBox-text"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="5"
              class="mb-2 boxFile"
            >
              <b-file-attach-input
                id="messageAttach"
                :key="isReset"
                v-model="form.messageFileId"
                :label="$t('general.attach') + ' ' + $t('general.acceptAttachFile')"
                :placeholder="$t('general.select')"
              />
            </b-col>
            <b-col
              cols="12"
              class="mt-50"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-1"
                :disabled="isSubmit"
                @click="submitForm"
              >
                {{ isSubmit ? $t("general.isSubmit") : $t("general.submit") }}
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                variant="outline-secondary"
                @click="$router.go(-1)"
              >
                {{ $t("general.back") }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card>
    </div>
    <div>
      <b-modal
        id="BMI"
        v-model="showMediaModal"
        size="lg"
        hide-footer
        hide-header
      >
        <div class="modal-dialog modal-lg modal-analayzer">
          <div class="modal-content">
            <div class="modal-header counseling">
              <h5 class="modal-title counseling">
                {{ $t('general.imagesCons') }}
              </h5>
              <feather-icon
                icon="XIcon"
                size="18"
                opacity="1"
                class="btn-close hover-scale-up"
                @click="closeMedia"
              />
            </div>
            <div class="modal-body">
              <div class="container">
                <ul
                  v-if="media"
                  class="media-box"
                >
                  <li
                    v-for="(image , index) in media"
                    :key="index"
                  >
                    <img
                      v-if="image"
                      :src="image | addBaseFileUrl()"
                      class="img-fluid"
                    >
                  </li>
                </ul>
                <ul v-else>
                  <li>
                    {{ $t('general.noImg') }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import {
  BButton, BCard, BCol, BForm, BFormGroup, BFormTextarea, BRow,
} from 'bootstrap-vue'
import './filters'
import BFileAttachInput from '@/components/BFileAttachInput/index.vue'
import '@/components/BFormInvalid/index.vue'
import ImageCell from '@/components/BDataTable/Elements/ImageCell.vue'
import LayoutLoading from '@/components/LayoutLoading.vue'
import Ripple from 'vue-ripple-directive'
import '@/components/VSelectCustom/index.vue'
import '@/components/VSelectCustom/VSelectOption.vue'
import useCounselingsList from './useCounselingsList'

export default {
  name: 'CounselingMessage',
  components: {
    BButton,
    BCard,
    BCol,
    BFileAttachInput,
    BForm,
    BFormGroup,
    BRow,
    ImageCell,
    LayoutLoading,
    BFormTextarea,
  },
  directives: {
    Ripple,
  },
  setup() {
    const {
      assignCounseling,
      counseling,
      fetchCounseling,
      fetchMessages,
      form,
      handleUpload,
      isSubmit,
      isViewable,
      itemLoading,
      messages,
      sendMessage,
      sendEdit,
    } = useCounselingsList('counseling/messages')
    return {
      assignCounseling,
      counseling,
      fetchCounseling,
      fetchMessages,
      form,
      handleUpload,
      isSubmit,
      isViewable,
      itemLoading,
      messages,
      sendMessage,
      sendEdit,
    }
  },
  data() {
    return {
      attachFile: null,
      isReset: false,
      media: [],
      showMediaModal: false,
      editModal: false,
      textEdit: null,
      imageEdit: null,
      MsgId: null,
      index: 0,
      replyMsg: false,
      newMessage: null,
      sender: '',
      imageMsg: '',
      messageId: null,
      parentMessageId: null,
      Reply: false,
    }
  },
  computed: {
    itemId() {
      return this.$router.currentRoute.params.id
    },
    render() {
      return this.messages && this.counseling ? this.messages.length : false
    },
  },
  created() {
    this.fetchCounseling(this.itemId)
    this.fetchMessages(this.itemId)
    this.form.messageFileIdAlt = 'messageFileId'
  },
  methods: {
    validateState(name) {
      const {
        $dirty,
        $error,
      } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    assignMe() {
      this.assignCounseling(this.itemId, {}).then(() => {
        this.fetchCounseling(this.itemId)
        this.fetchMessages(this.itemId)
      })
    },
    submitForm() {
      const uploadList = ['messageFileId']
      this.handleUpload(this.form, uploadList).then(newForm => {
        this.sendData(newForm)
      })
    },
    formSumbit(messages) {
      const uploadList = ['messageFileId']
      this.MsgId = messages[this.index]._id
      this.handleUpload(this.form, uploadList).then(newForm => {
        this.EditMessage(newForm)
      })
    },
    EditMessage(form) {
      let data = {}
      if (this.textEdit && form.messageFileId) {
        data = {
          text: this.textEdit,
          messageFileId: form.messageFileId._id,
        }
      } else if (form.messageFileId) {
        data = {
          messageFileId: form.messageFileId._id,
        }
      } else if (this.textEdit) {
        data = {
          text: this.textEdit,
        }
      } else if (!this.textEdit && !form.messageFileId) {
        alert(this.$t('validator.emptyMessage'))
        return false
      }
      return this.sendEdit(this.MsgId, data, form.lang).then(() => {
        this.isReset = !this.isReset
        this.editModal = false
        this.fetchMessages(this.itemId)
      })
    },
    sendData(form) {
      let data = {}
      if (form.message && form.messageFileId) {
        data = {
          text: form.message,
          messageFileId: form.messageFileId._id,
        }
      } else if (form.messageFileId && this.parentMessageId) {
        data = {
          messageFileId: form.messageFileId._id,
          parentMessageId: this.messageId,
        }
      } else if (form.message && this.parentMessageId) {
        data = {
          text: form.message,
          parentMessageId: this.messageId,
        }
      } else if (form.message) {
        data = {
          text: form.message,
        }
      } else if (form.messageFileId) {
        data = {
          messageFileId: form.messageFileId._id,
        }
      } else if (!form.message && !form.messageFileId) {
        alert(this.$t('validator.emptyMessage'))
        return false
      }
      return this.sendMessage(this.itemId, data, form.lang).then(() => {
        this.isReset = !this.isReset
        this.replyMsg = false
        this.Reply = true
        this.parentMessageId = this.messageId
        this.fetchMessages(this.itemId)
        this.parentMessageId = null
      })
    },
    showMedia() {
      this.showMediaModal = true
      this.media = this.messages.map(item => item.messageFileId)
    },
    closeMedia() {
      this.showMediaModal = false
    },
    editMsg(message, index) {
      this.editModal = !this.editModal
      this.textEdit = message.text
      this.index = index
    },
    closeEdit() {
      this.editModal = false
    },
    replaceURLs(message) {
      if (!message) return undefined
      const urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g
      return message.replace(urlRegex, url => {
        let hyperlink = url
        if (!hyperlink.match('^https?://')) {
          hyperlink = `http://${hyperlink}`
        }
        return `<a href="${hyperlink}" target="_blank" rel="noopener noreferrer">${url}</a>`
      })
    },
    reply(message, index) {
      this.replyMsg = true
      this.imageMsg = message.messageFileId
      this.newMessage = this.messages[index].text
      if (message.status === 'repliedByAdmin') {
        this.sender = 'مشاور'
      } else {
        this.sender = 'کاربر'
      }
      this.messageId = this.messages[index]._id
      this.parentMessageId = this.messageId
    },
    cancleRep() {
      this.replyMsg = false
      this.newMessage = ''
      this.messageId = null
      this.parentMessageId = null
    },
  },
}
</script>
<style>
.flex-md-row-reverse .bg-response{
  background-color: #cbf5ff !important;
  text-align: right;
  border-radius: 20px 10px 10px 20px;
}
.message{
  border-radius: 10px 20px 20px 10px;
  white-space: pre-line;

}
.flex-md-row-reverse .avatar{
  background-color: #006aff;
}
.avatar{
  background-color: #01907b;
  margin: 0 auto;
  border-radius: 50%;
  width: 30px;
  height: 30px;
}
.chat-info{
  font-size: 11px;
}
.chat-info{
  text-align: right;
  direction: rtl;
}
.flex-md-row-reverse .chat-info{
  text-align: left;
}
.user-name{
  margin-top: 0.5em;
}
.margin-auto{
  margin: auto;
}
.media-counseling button{
  width: 100%;
  height: 35px;
  background: none;
}
.btn-close{
  color: #000;
  border-radius: 50%;
  border: 1px solid #000;
  padding: 1px;
}
.modal-content{
  box-shadow: none !important;
}
.modal-header{
  background: none !important;
}
.modal-title{
  font-size: 16px;
  font-weight: 500;
  color: #141515;
}
@media(max-width:767px){
  .user-name{
    margin-right: 5px;
  }
}
@media(max-width:575px){
.message{
    width: 100% !important;
    margin-top: 5px;
  }
  .messageBox{
    flex-direction: column !important;
  }
  .messageBox-text{
    width: 470px;
  }
  .boxFile{
    max-width: 100%;
  }
  .avatar{
    margin-left: 0 !important;
  }
  .box-messages{
    padding: 15px !important;
  }
}
@media(max-width:480px){
  .messageBox-text{
    max-width: 100%;
  }
}
.iconEdit{
  cursor: pointer;
  margin: 3px;
}
.media-box{
  padding: 0;
  display: flex;
  flex-wrap: wrap;
}
.media-box li{
  width: 15%;
  height: 100px;
  margin-bottom: 15px;
  list-style: none;
  position: relative;
  box-shadow:1px 3px 9px rgb(189, 183, 183);
  margin-left: 10px;

}
.media-box .coption{
  position: absolute;
  bottom: -4px;
  width: 100%;
  background: #e9eff1cf;
  word-break: break-all;
}
.media-box .coption p{
margin: 0;
font-size: 11px;
}
.media-box img{
  height: 100%;
width: 100%;
overflow: hidden;
}
.imageMessage{
  margin-bottom: 5px;
}
.replyMsg{
  background: #8db3bc26;
  padding: 1rem;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.replyMsg button{
  border: none;
  background: none !important;
}
.replyMsg .newMessage{
  margin-right: auto;
  padding: 0 10px;
  word-break: break-all;
  overflow: hidden;
}
.replyMsg .sender{
  white-space: nowrap;
}
.rep-message{
  margin-bottom: 5px;
}
.rep-message p{
  word-break: break-all;
}
.rep-message .oldMsg{
  margin: 0 !important;
  background: rgba(236, 234, 234, 0.611);
  padding: 3px 5px;
}
/*  */
@media(max-width:991px){
  .messageBox.edit{
    flex-direction: column;
    margin-top: 0 !important;
  }
  .messageBox.edit textarea.form-control{
    width: 390px;
  }
  .messageBox.edit .boxFile .border {
    width: 390px;
  }
}
@media(max-width:575px){
.modal-body{
  padding: 1rem 0 !important;
}
.messageBox.edit textarea.form-control{
    width: 491px;
  }
  .messageBox.edit .boxFile .border {
    width: 491px;
  }
}
@media(max-width:480px){
.modal-body{
  padding: 1rem 0 !important;
}
.messageBox.edit textarea.form-control{
    max-width: 100%;
    width: 100%;
  }
  .messageBox.edit .boxFile .border {
    width: 100%;
  }
}
@media(max-width:375px){
.modal-body{
  padding: 1rem 0 !important;
}
}
.rep-message{
  background: #eaeaea69;
  width: 100%;
  margin-bottom: 0;
  display: flex;

}
.rep-message p{
  margin-bottom: 5px;
  padding:  0 5px;
}
.message-link{
  color: rgb(24, 117, 198);
 line-height: 10px;
}
.message-link:hover{
  color: rgb(24, 117, 198);
}
</style>
